import React, { useRef } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import './PlayWith3almny.css';

const PlayWith3almny = () => {
  const iframeRef = useRef(null);
  const { isDarkMode } = useDarkMode();

  const handleFullscreen = () => {
    if (iframeRef.current) {
      if (iframeRef.current.requestFullscreen) {
        iframeRef.current.requestFullscreen();
      } else if (iframeRef.current.webkitRequestFullscreen) {
        iframeRef.current.webkitRequestFullscreen();
      } else if (iframeRef.current.msRequestFullscreen) {
        iframeRef.current.msRequestFullscreen();
      }
    }
  };

  return (
    <div className={`play-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      {/* Header Section */}
      <div className="play-header">
        <div className="container">
          <div className="play-header-content">
            <div className="play-breadcrumb">
              <a href="/" className="breadcrumb-link">الرئيسية</a>
              <span className="breadcrumb-separator">/</span>
              <span className="breadcrumb-current">امرح مع علمني</span>
            </div>
            <h1 className="play-title">امرح مع علمني</h1>
            <p className="play-description">
              استمتع باللعب والتعلم في نفس الوقت! العب ألعاب تعليمية ممتعة وتعلم مفاهيم جديدة بطريقة تفاعلية.
            </p>
          </div>
        </div>
      </div>

      {/* Game Content */}
      <div className="play-content">
        <div className="container">
          <div className="play-grid">
            {/* Game Info Card */}
            <div className="play-info-card">
              <div className="play-info-header">
                <div className="play-icon">
                  <i className="fas fa-gamepad"></i>
                </div>
                <h3>معلومات اللعبة</h3>
              </div>
              <div className="play-info-content">
                <div className="info-item">
                  <span className="info-label">اسم اللعبة:</span>
                  <span className="info-value">HexGL</span>
                </div>
                <div className="info-item">
                  <span className="info-label">النوع:</span>
                  <span className="info-value">سباق ثلاثي الأبعاد</span>
                </div>
                <div className="info-item">
                  <span className="info-label">المستوى:</span>
                  <span className="info-value">جميع الأعمار</span>
                </div>
                <div className="info-item">
                  <span className="info-label">التحكم:</span>
                  <span className="info-value">أسهم لوحة المفاتيح</span>
                </div>
              </div>
            </div>

            {/* Game Frame */}
            <div className="play-game-card">
              <div className="game-header">
                <h3>HexGL - سباق المستقبل</h3>
                <div className="game-controls">
                  <button className="btn btn-primary btn-sm" onClick={handleFullscreen}>
                    <i className="fas fa-expand"></i>
                    ملء الشاشة
                  </button>
                </div>
              </div>
              <div className="game-container">
                <iframe 
                  ref={iframeRef}
                  src="https://www.gameflare.com/embed/hexgl/" 
                  frameBorder="0" 
                  scrolling="no" 
                  width="900" 
                  height="635" 
                  allowFullScreen
                  title="HexGL Game"
                  className="play-iframe"
                />
              </div>
            </div>

            {/* Instructions Card */}
            <div className="play-instructions-card">
              <div className="instructions-header">
                <h3>تعليمات اللعبة</h3>
              </div>
              <div className="instructions-content">
                <div className="instruction-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>التحكم</h4>
                    <p>استخدم أسهم لوحة المفاتيح للتحكم في المركبة</p>
                  </div>
                </div>
                <div className="instruction-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>الهدف</h4>
                    <p>اجمع النقاط وتجنب العقبات للوصول لأعلى نتيجة</p>
                  </div>
                </div>
                <div className="instruction-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>السرعة</h4>
                    <p>كلما تقدمت في اللعبة زادت السرعة والتحدي</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayWith3almny; 